import { Label } from "@onair/minimal-ui/label";
import { OnlineCourseStatus } from "@onair/repositories";
import React from "react";

const OnlineCourseStatusLabel: React.FC<{
	status: OnlineCourseStatus
}> = ({ status }) => {
	switch (status) {
		case OnlineCourseStatus.PUBLISHED:
			return <Label color="success">Xuất bản</Label>;
		case OnlineCourseStatus.REVIEWED:
			return <Label color="secondary">Chờ kiểm duyệt</Label>;
		case OnlineCourseStatus.REJECTED:
			return <Label color="error">Bị từ chối</Label>;
		case OnlineCourseStatus.UNPUBLISHED:
			return <Label color="default">Dừng xuất bản</Label>;
		case OnlineCourseStatus.PENDING_APPROVAL_WITH_ADMIN:
			return <Label color="warning">Chờ kiểm duyệt</Label>;
		case OnlineCourseStatus.DRAFT:
			return <Label color="warning">Bản nháp</Label>;
		default:
			return null;
	}
}

export default OnlineCourseStatusLabel;
